import React, { Component } from 'react';
import { singleTick, doubleTick } from '../../../../images/images';
import Shimmer from 'sushiweb/Shimmer';
import './ValetInstructions.scss';
import { AudioPlayer, Tooltip } from '../../../../UiKit';
import { AddInstructions } from '../../../commons';
import { AddEdit } from 'sushiweb/Icons';
import EditValetInstruction from './EditValetInstruction';
import { OrderRiderImages } from '../OrderRiderImages/OrderRiderImages';

export default class ValetInstructions extends Component {
  render() {
    const { order } = this.props;
    return (
      <div className='valetInstructionContainer'>
        {!order ? (
          <Shimmer height='120px' width='100%' />
        ) : (
          <ValetInstructionsComp {...this.props} />
        )}
      </div>
    );
  }
}

class ValetInstructionsComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTextBoxOpen: false,
      isEditInstructionOpen: false,
    };
  }

  checkIfTextBoxIsOpen = (isTextBoxOpen) => {
    this.setState({
      isTextBoxOpen: isTextBoxOpen,
    });
  };

  handleInstructionModal = () => {
    let prevState = this.state.isEditInstructionOpen;
    this.setState({
      isEditInstructionOpen: !prevState,
    });
  };

  render() {
    const { order } = this.props.order;
    if (!order) return null;
    const {
      valet_instruction_seen,
      is_contactless,
      address_instruction,
      contactless_image,
      audio_instruction,
      delivery_instruction = [],
    } = order;
    const { isTextBoxOpen, isEditInstructionOpen } = this.state;
    let deliveryInstructionsString = '';

    if (delivery_instruction) {
      delivery_instruction.map((item) => {
        deliveryInstructionsString = deliveryInstructionsString + item + ' , ';
      });
      deliveryInstructionsString = deliveryInstructionsString.replace(
        /,\s*$/,
        '',
      );
    }

    return (
      <div className='valetInstructions '>
        <div className='valetInstructionHeader'>
          <p className='lighter'>
            Valet Instructions
            {valet_instruction_seen ? (
              <span className='tickImg iconMarginL'>
                <img src={doubleTick} alt='' />
              </span>
            ) : (
              <span className='tickImg iconMarginL'>
                <img src={singleTick} alt='' />
              </span>
            )}
          </p>
          {order?.order_id && !order?.is_live && (
            <OrderRiderImages orderId={order?.order_id} />
          )}
          {order?.is_live && (
            <div
              className='updateInstructionTooltip'
              role='button'
              tabIndex={0}
              onClick={this.handleInstructionModal}
            >
              <Tooltip
                position='top'
                border={false}
                title={<AddEdit size={15} color='#cecece' />}
                label='Add/Update Delivery Instructions'
                fontWeight={300}
                fontSize={14}
                widthMaxContent={true}
                labelWidth={30}
              />
            </div>
          )}
          {isEditInstructionOpen && order?.order_id && (
            <EditValetInstruction
              isEditInstructionOpen={isEditInstructionOpen}
              closeModal={this.handleInstructionModal}
              orderId={order?.order_id}
              refetchInstruction={this.props.retry}
            />
          )}
        </div>
        {delivery_instruction && !isTextBoxOpen && (
          <div>
            {delivery_instruction && <p>{deliveryInstructionsString}</p>}
          </div>
        )}

        {order.delivery_instruction_allowed && (
          <AddInstructions
            oldInstruction={address_instruction}
            orderId={order?.order_id}
            target='delivery'
            updateaInstruction={this.props.retry}
            checkIfTextBoxIsOpen={this.checkIfTextBoxIsOpen}
          />
        )}
        {audio_instruction && <AudioPlayer src={audio_instruction} />}
        {is_contactless && contactless_image && (
          <div className='contectLessPhoto pt10'>
            <a
              href={contactless_image}
              className='colorGreen'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Photo
            </a>
          </div>
        )}
      </div>
    );
  }
}
